import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_URL + '/api/transaction';

class TransactionService {
    store(data) {
        return axios.post(API_URL, data, { headers: authHeader() });
    }

    update(id, data) {
        return axios.post(API_URL + '/' + id + '?_method=PUT', data, { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } });
    }

    show(id) {
        return axios.get(API_URL + '/' + id, { headers: authHeader() });
    }

    status(data) {
        return axios.post(API_URL + '/status', data, { headers: authHeader() });
    }

    cancelPayment(id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/cancelPayment/transaction';
        return axios.get(url + '/' + id, { headers: authHeader() });
    }

    getByUserIds(data) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getByUserIds/transaction';
        return axios.post(url, data, { headers: authHeader() });
    }

    reloadExternalApi(tx_product_id) {
        return axios.post(API_URL + '/reloadExternalApi/' + tx_product_id, [], { headers: authHeader() });
    }

    getProcessByTransactionId(transaction_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getByTransactionId/transaction_process';
        url += '/' + transaction_id;

        return axios.get(url, { headers: authHeader() });
    }

    getNotificationCountByUserId(user_id, status = null) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getNotificationCountByUserId/transaction';
        url += '/' + user_id;
        if (status) {
            url += '/' + status;
        }
        return axios.get(url, { headers: authHeader() });
    }

    generatePaymentLink(id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/generatePaymentLink/transaction';
        url += '/' + id;
        return axios.get(url, { headers: authHeader() });
    }

    getMikrotikBillingById(mikrotik_billing_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/mikrotik_billing';
        url += '/' + mikrotik_billing_id;

        return axios.get(url, { headers: authHeader() });
    }

    readdItems(id) {
        return axios.post(API_URL + '/readdItems/' + id, [], { headers: authHeader() });
    }
}

export default new TransactionService();
